import { HTMLAttributes } from 'react';
import { Container } from '../Container/Container';

export const Banner = ({
  className = '',
  children,
  innerClassName = '',
  ...rest
}: { innerClassName?: string } & HTMLAttributes<HTMLDivElement>) => (
  <div className={`w-full ${className}`} {...rest}>
    <Container className={innerClassName}>{children}</Container>
  </div>
);
